// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"5d4c461c","839":"a48b38a9","842":"80092eda","880":"144ef1a3"}[chunkId] + ".chunk.js";
};